<template>
  <div class="container">
    <h1>
      <b-icon icon="person-square"></b-icon> Registration
      <div class="float-right" style="margin-top: -62px">
        <b-button
          v-b-modal.modal-help
          v-b-tooltip.hover
          title="Help"
          class="help"
        >
          <b-icon icon="question-square-fill"></b-icon> Help</b-button
        >
<help id="11" />
      </div>
    </h1>

    <div class="row">
      <div class="col-md-3 img-responsive">
        <img
          src="../../assets/RegistrationHome.jpg"
          width="350"
          alt="Circle image"
          class="militray-img"
        />
      </div>
      <div class="col-md-9 pt-4">
        <div class="panal mt-20" style="margin-left: -48px">
          <div class="panal-body row pl-5">
            <h1 class="w-100">Information About Registration</h1>
            <p>
              The Registration Center guides for students when you select any
              course You can add courses to the cart by selecting one of all the
              subtypes available times each course you choose will be added to
              the cart
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="row w-100">

    <div class="panal col-md-12" v-if="status.StudentRegistrationApproval != 1 && status.AdvisingStatus != true">
            <div>
              <div class="panal-header">Select Courses </div>
              <!-- <div class="panal-body" id="Courses">
            
             
                
                  <label class="col-md-2">Student level</label>
                  <b-form-select v-model="LevelNameinsert" class="col-md-4" v-b-tooltip.hover title="Student level">
                    <b-form-select-option
                      v-for="Level in LevelName"
                      v-bind:key="Level.serial"
                      :value="Level.serial"
                      >{{ Level.StageName }}
                      </b-form-select-option>
                  </b-form-select>
               

                <hr />
                <div>
                
                  <label class="col-md-2">Student Specialization</label>
                  <b-form-select v-b-tooltip.hover title="Student Specialization"
                    v-model="Specializationinsert"
                    class="mb-3 col-md-4"
                  >
                   
                    <b-form-select-option
                      v-for="spac in Specialization"
                      v-bind:key="spac.SpecializationID"
                      :value="spac.SpecializationID"
                      >{{ spac.SpecializationNameEN }}</b-form-select-option
                    >
                  </b-form-select>
                </div>

                <hr />
                <div class="row">
                
                 
                    <label class="col-md-2 ml-3 mt-1">Course Code</label>
                    <b-form-input v-b-tooltip.hover title="Course Code"
                      v-model="courseCode"
                      class="col-md-3"
                      placeholder="Enter course code"
                    ></b-form-input>
                    <b-col class="col-md-2 mt-1">Course Name</b-col>
                    <b-form-input v-b-tooltip.hover title="Course Name"
                      v-model="courseName"
                      class="col-md-4"
                      placeholder="Enter course Name"
                    ></b-form-input>
                 
                </div>
              </div> -->
            </div>
    <div class="panal-body">
      Please click Register to select your courses 
    </div>
    <div class="col-md-12 text-center" v-if="basicCourses.length >0">

      <h5>Your Currently selected Courses</h5>
    </div>
    <div class="row m-1">
      
      <div class="text-center" v-if="loadCourses ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
      <div 
            v-for="(request, index) of basicCourses"
            :key="index"
            class="col-md-4 col-sm-12 mb-5"
            border-variant="primary"
          >
          
            <div class="card p-4">
              <b-card-text
                ><strong
                  >Course Code :
                  <span class="customeP">{{ request.CourseCode }} </span>
                </strong>
              </b-card-text>
              <b-card-text
                ><strong
                  >Course Name :
                  <span class="customeP">{{ request.CourseNameEN }} </span>
                </strong>
              </b-card-text>
            
  
           
              <div class="clearfix"></div>
            </div>
            </div>
    </div>
             <div class="text-center col-md-3 float-right">
            <b-button
             :disabled="!allowUpdateDrop"
              class="mt-3  btn-success"
              block
              @click="()=>$router.push('/selectsubject')"
              > <span v-show="loading" class="spinner-border spinner-border-sm"></span>
              Register</b-button
            >
          </div>
          </div>
         
    <div class="panal col-md-12" v-if="status.StudentRegistrationApproval == 1 && status.AdvisingStatus == true">
            <div>
              <div class="panal-header">Note</div>
              <div class="panal-body" id="Courses">
             <div class="panal-body row pl-5">
            <h1 class="w-100">You are Currently working with a SuperVisor </h1>
            <p>
              Your Academic Advisor provided you with list of courses as approved to register from and put another list of courses as forbidden not to select from    
            </p>
          </div>
              </div>
            
             <div class="text-center col-md-3 float-right">
            <b-button
              class="  btn-success"
              block
              @click="()=>$router.push('/selectsubject')"
              >Register</b-button
            >
         
          </div>
             <div class="text-center col-md-3 float-right">
            <b-button
              class="  btn-primary"
              block
              @click="()=>$router.push('/ApprovedCourses')"
              >View Approved and Forbidden courses</b-button
            >
         
          </div>
          </div>


  

        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>


import SelectSubject from "../../services/academic/SelectSubject.services";
//import ApplicantService from "../../services/Applicant/Applicant.service";
//import StudentAdvisorServices from '../../services/academic/StudentAdvicessServices'
import Help from '../Help.vue';

export default {
  components: { Help },
  name: "SelectSubject",
  data() {
    return {
      empty : true, 
      info:"",
      LevelName : [],
        message:'',
        Specialization:[],
        courseCode:'',
        courseName:'',
        Specializationinsert:null,
        LevelNameinsert:null,
        status : [],
        basicCourses:[],
        allowUpdateDrop:false,
        loading:false,
        loadCourses:false
    };
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
    StudentStatus(){
          this.$store.dispatch('Advisor/AdvisorStatus',this.currenUser.StudentID)

    return this.$store.state.Advisor
    }
  },

  created(){
    this.$store.dispatch('Advisor/AdvisorStatus',this.currenUser.StudentID)

      // SelectSubject.GetFacultyLevels(this.currenUser.FacultyID_Enrollment).then(Response =>{
               
      //          this.LevelName = Response.data
      //           this.empty =false
      //           // console.log('levels name: ', this.LevelName)
      //      }, error => {
      
      //         this.message =
      //           (error.response && error.response.data && error.response.data.Message) ||
      //           error.message ||
      //           error.toString();
                
      //           if(error.response.status == 404) this.message =''
             
      //       }) 
       
      // SelectSubject.GetFacultySpecializations(this.currenUser.FacultyID_Enrollment).then(Response =>{
             
      //          this.Specialization = Response.data
      //           this.empty =false
            
      //      }, error => {
              
      //             // eslint-disable-next-line no-console
      //             // console.log(error.response.status)
                 
      //         this.message =
      //           (error.response && error.response.data && error.response.data.Message) ||
      //           error.message ||
      //           error.toString();
                
      //           if(error.response.status == 404) this.message =''
             
      //       }) 
      // StudentAdvisorServices.StudentAdvisingStatus(this.currenUser.StudentID).then((Response) => {
        
      //   this.status = Response.data[0]
      //     // eslint-disable-next-line no-console
      //      console.log("Select Subject ", Response.data);
      //   },
      //   (error) => {
        
    
      //     this.message =
      //       (error.response &&
      //         error.response.data &&
      //         error.response.data.Message) ||
      //       error.message ||
      //       error.toString();

      //     if (error.response.status == 404) this.message = "";
      //   }
      // );
  },

  async mounted() {
    
   await this.GetRegistrationPeriodSelect(this.currenUser.StudentID)
    await this.SelectBasicCourses()
  },

  methods: {
   
    SelectBasicCourses(){
     this.loadCourses = true
      SelectSubject.SelectBasicCourses(this.currenUser.StudentID).then(res=>{
        this.basicCourses = res.data
       this.loadCourses =false
      }).catch(()=>{
        this.loadCourses = false
      })
    },
    async  GetRegistrationPeriodSelect(){
      this.loading = true
    SelectSubject.GetRegistrationPeriodSelect(this.currenUser.StudentID).then(res=>{
              //console.log(res.data)
              this.allowUpdateDrop = res.data[0].IsActive
              this.loading = false
            }).catch(()=>{
              this.loading = false
            })
           }

  },
};
</script>

<style scoped>
.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
.modal-footer {
  background: #f6f6f6 !important;
}

.panal {
  background: rgb(255, 255, 255);
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
    background: #285475;
    color: #ffffff;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
    width: 50%;
}
.panal-body {
  padding: 20px;
  color: #333;
}

/* Style the tabs */
.tabs {
  overflow: hidden;
  margin-left: 20px;
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 12px 24px;
  transition: background-color 0.2s;
  border: 1px solid #ccc;
  border-right: none;
  background-color: #285475;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  color: #fff;
}
.tabs a:last-child {
  border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #285475;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }
  .app-stu-photo {
    float: none;
  }
  img {
    width: 69vw !important;
  }
}
.spicon {
  color: #ff8600;
  font-size: 45px;
  font-weight: 800;
}
.customeP {
  /* white-space: nowrap; */
  font-weight: 100;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
</style>
